import { render } from "./AddProfessional.vue?vue&type=template&id=354c18be"
import script from "./AddProfessional.vue?vue&type=script&lang=js"
export * from "./AddProfessional.vue?vue&type=script&lang=js"

import "./AddProfessional.vue?vue&type=style&index=0&id=354c18be&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__